import React, { Fragment } from 'react';
import { createPortal } from 'react-dom';
import MovePageModal from '../move/MovePageModal';

class MovePageWrapper extends React.Component {
    state = { showModal: false };

    openModal = () => this.setState({ showModal: true });

    closeModal = () => this.setState({ showModal: false });

    render() {
        const { showModal } = this.state;
        const { page } = this.props;

        return (
            <Fragment>
                <span className="dropdown-option move-modal-link link" onMouseDown={this.openModal}>Move</span>
                {showModal && createPortal(<MovePageModal page={page} closeModal={this.closeModal} />, document.body)}
            </Fragment>
        );
    }
}

export default MovePageWrapper;
